import { connect } from 'react-redux';
import { compose } from 'recompose';
import selectors from 'state/settings/selectors';

const withLocale = compose(
  connect((state) => ({
    locale: selectors.getLocale(state),
  }))
);

export default {
  withLocale,
};
